




















import { mapActions } from 'vuex';
import { filter } from 'lodash';

import ZenButton from '@reciprocity/button';

export default {
  name: 'ZenTableColumnsSettings',
  components: {
    ZenButton,
  },
  props: {
    objectType: {
      // In ModelMetaSchema.modelSingular form
      type: String,
      required: true,
    },
    activeColumns: {
      type: Array,
      required: true,
    },
    colReorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      columns: [],
    };
  },
  computed: {
    loading(): boolean {
      return this.$apollo.queries.columns.loading;
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
    }),
    async open() {
      try {
        const selectedColumns = await this.showModal({
          type: 'ColumnSettingsModal',
          data: {
            objectType: this.objectType,
            activeColumns: this.activeColumns,
            columns: this.columns,
          },
        });
        this.$emit('columnsChange', selectedColumns);
      } catch (type) {
        if (type === 'columnsReset') {
          this.$emit('columnsReset');
        }
      }
    },
  },
  apollo: {
    columns: {
      query: require('@/graphql/listing/Columns.gql'),
      variables() {
        return {
          type: this.objectType,
          context: 'SOR_LISTING',
        };
      },
      manual: true,
      result({ data }) {
        this.columns = filter(data.objectType.attrs, attr => attr.sorListing);
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      },
    },
  },
};
